import React, {Component, Fragment} from "react";
import UpcomingMatchesDataTable from "./datatables/UpcomingMatchesDataTable";
import UpcomingMatchesFilters from "./filters/UpcomingMatchesFilters";
import '../../../../assets/sass/pages/matches-and-events/upcoming-matches.scss';

class UpcomingMatches extends Component {
    state = {
        search: null,
        regions: [],
        countries: [],
        competitions: [],
        teams: [],
        venues: [],
    };

    render = () => {
        return (
            <div className="upcoming-matches">
                {this.renderFilters()}
                {this.renderDataTable()}
            </div>
        );
    };

    renderFilters = () => {
        return (
            <UpcomingMatchesFilters onChange={this.handleFiltersChange}/>
        );
    };

    renderDataTable = () => {
        const {regions, countries, competitions, teams, venues, search} = this.state;

        return (
            <UpcomingMatchesDataTable search={search} regions={regions} countries={countries} competitions={competitions} teams={teams} venues={venues}/>
        );
    };

    handleFiltersChange = options => this.setState({
        regions: options?.regions?.map(item => item.value),
        countries: options?.countries?.map(item => item.value),
        competitions: options?.competitions?.map(item => item.value),
        teams: options?.teams?.map(item => item.value),
        venues: options?.venues?.map(item => item.value),
        search: options?.search,
    });
}

export default UpcomingMatches;
